import { render, staticRenderFns } from "./discardChangesModal.vue?vue&type=template&id=60c49bfa&scoped=true"
import script from "./discardChangesModal.vue?vue&type=script&lang=js"
export * from "./discardChangesModal.vue?vue&type=script&lang=js"
import style0 from "./discardChangesModal.vue?vue&type=style&index=0&id=60c49bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c49bfa",
  null
  
)

export default component.exports